export const ENV = {
  VAPID_PUBLIC_KEY: "BBe2HJ4RP93PKFUZmW2ZRPO1-y3bkOMK29GBYM6whWCzhBS0dymKmAhw-Blnh5D-utPYgQfuPFifrSJYDHtIopY",
};
